import React, { FC } from "react";
import { Form, Input, DatePicker, Row, Col, Select } from "antd";

interface EchsEmergencyAdmissionFormProps {
  form: any;
  loading?: boolean;
  disabled: any;
  polyclinicList?: any[];
}

const EchsEmergencyAdmissionForm: FC<EchsEmergencyAdmissionFormProps> = ({
  form,
  loading,
  disabled,
  polyclinicList,
}) => {
  return (
    <div className="echs-emergency-admission-form">
      <Form
        form={form}
        labelAlign="left"
        layout="vertical"
        labelWrap
        style={{ width: "100%" }}
      >
        <Row gutter={[16, 16]} className="form-row">
          <Col span={4}>
            <Form.Item
              name="beneficiaryId"
              label="BENEFICIARY ID"
              rules={[
                { required: true, message: "Please Input Beneficiary Id" },
              ]}
            >
              <Input disabled={disabled} placeholder="Enter Beneficiary ID" />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item
              name="patientOpdIpdNumber"
              label="ADMISSION OPD NUMBER"
              rules={[
                {
                  required: true,
                  message: "Please input admission opd number",
                },
              ]}
            >
              <Input
                disabled={disabled}
                placeholder="Enter Admission OPD Number"
              />
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item
              name="approxTreatmentCost"
              label="APPROX TREATMENT COST"
              rules={[
                { required: true, message: "*" },
                {
                  pattern: /^\d+$/,
                  message: "Only Numeric values are allowed!",
                },
              ]}
            >
              <Input placeholder="Enter Treatment Cost" disabled={disabled} />
            </Form.Item>
          </Col>

          <Col span={5}>
            <Form.Item
              name="roomType"
              label="ROOM TYPE"
              rules={[{ required: true, message: "*" }]}
            >
              <Select placeholder="Select Room Type" disabled={disabled}>
                <Select.Option value="General">GENERAL</Select.Option>
                <Select.Option value="Private">PRIVATE</Select.Option>
                <Select.Option value="Semi-Private">SEMI PRIVATE</Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item
              name="roomNumber"
              label="ROOM NUMBER"
              rules={[{ required: true, message: "*" }]}
            >
              <Input disabled={disabled} placeholder="Enter Room Number" />
            </Form.Item>
          </Col>

          <Col span={5}>
            <Form.Item
              name="polyclinicName"
              label="POLYCLINIC"
              // rules={[{ required: true, message: "Please select polyclinic" }]}
            >
              <Select placeholder="Select Polyclinic" disabled={disabled}>
                {polyclinicList?.map((item: any) => (
                  <Select.Option key={item.id} value={item.name}>
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item
              name="opdDate"
              label="ADMISSION/OPD DATE/TIME"
              rules={[{ required: true, message: "*" }]}
            >
              <DatePicker
                showTime
                format="DD-MM-YYYY HH:mm:ss"
                style={{ width: "100%" }}
                placeholder="Select Date and Time"
                disabled={disabled}
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              name="expectedDischargeDate"
              label="EXPECTED DISCHARGE DATE/TIME"
              rules={[{ required: true, message: "*" }]}
            >
              <DatePicker
                showTime
                format="DD-MM-YYYY HH:mm:ss"
                style={{ width: "100%" }}
                placeholder="Select Date and Time"
                disabled={disabled}
              />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item
              name="remarks"
              label="REMARKS"
              rules={[{ required: true, message: "Please, enter remarks" }]}
            >
              <Input disabled={disabled} placeholder="Enter Remarks" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default EchsEmergencyAdmissionForm;
